import React, { useState, useEffect } from "react";
import NewScheduleIcon from "../../../../assets/icons/new_schedule.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import moment from "moment";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { getAdminBusinessId, getLoggedInUserId } from "../../../../utils/authHelper";
import { connect, useDispatch } from "react-redux";
import { sendPostRequest } from "../../../../actions/app-actions";
import {
  CHANNELS_LOADED,
  UPDATE_NOTIFICATIONS,
  APPEND_NOTIFICATIONS,
} from "../../../../actions/types";
import { Link, useNavigate } from "react-router-dom";

let isAdminChannelsLoaded = false;
let totalUnread = 0;
let notifications = [];

const isNotificationUnread = (notification) => notification?.is_seen === "D";

const notificationItemClass = (notification) =>
  `notification-item${isNotificationUnread(notification) ? " unread" : ""}`;

const Notification = ({
  onlyUnreadNoti: onlyUnreadProp,
  onOnlyUnreadChange,
  ...props
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [notiDropdownOpen, setNotiDropdownOpen] = useState(false);
  const [onlyUnreadLocal, setOnlyUnreadLocal] = useState(false);
  const onlyUnreadNoti =
    typeof onlyUnreadProp === "boolean" ? onlyUnreadProp : onlyUnreadLocal;
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 7,
  });

  const notiToggle = () => setNotiDropdownOpen((prevState) => !prevState);

  const goToNotiSettings = () => {
    navigate("/admin/notification-settings");
  };

  const loadMoreNotifications = () => {
    fetchNotifications(pagination.pageSize, pagination.current + 1);
  };

  /**
   * fetch notifications
   * @param {*} pageSize
   * @param {*} pageNumber
   */
  const fetchNotifications = (pageSize, pageNumber, onlyUnread = onlyUnreadNoti) => {
    const { sendPostRequest } = props;
    const replace = pageNumber === 1;
    setPagination({
      current: pageNumber,
      pageSize,
    });
    sendPostRequest({
      url: `/admin/notifications/${getAdminBusinessId()}/${getLoggedInUserId()}`,
      data: {
        pageSize,
        pageNumber,
        ...(onlyUnread ? { only_unread: "E" } : {}),
      },
      onSuccess: function (response) {
        const { data } = response;
        totalUnread = data.totalUnreadNotifications;

        if (replace) {
          setTotalCount(data.totalCount);
        }

        notifications = [...data.data];
        dispatch({
          type: APPEND_NOTIFICATIONS,
          payload: {
            totalUnread,
            notifications,
            replace,
          },
        });
      },
      onError: function (error) {
        console.log("error", error);
      },
    });
  };

  useEffect(() => {
    setTotalCount(0);
    fetchNotifications(pagination.pageSize, 1, onlyUnreadNoti);
  }, [onlyUnreadNoti]);

  useEffect(() => {
    if (!props.layout.isChannelsLoaded && !isAdminChannelsLoaded) {
      isAdminChannelsLoaded = true;
      dispatch({
        type: CHANNELS_LOADED,
        payload: true,
      });
      const channel = window.Echo.channel(`notifications-staff-${getAdminBusinessId()}-${getLoggedInUserId()}`);
      channel
        .subscribed(() => {
          console.log("subscribed");
        })
        .listen(".event-booked", (data) => {
          console.log("event", data);
          totalUnread++;
          notifications = [data];
          dispatch({
            type: UPDATE_NOTIFICATIONS,
            payload: {
              totalUnread,
              notifications,
            },
          });
        });

      channel.listen(".event-cancelled", (data) => {
        console.log("event", data, "unread", totalUnread);
        totalUnread++;
        notifications = [data];
        dispatch({
          type: UPDATE_NOTIFICATIONS,
          payload: {
            totalUnread,
            notifications,
          },
        });
      });

      channel.listen(".event-rescheduled", (data) => {
        console.log("event", data, "unread", totalUnread);
        totalUnread++;
        notifications = [data];
        dispatch({
          type: UPDATE_NOTIFICATIONS,
          payload: {
            totalUnread,
            notifications,
          },
        });
      });
    }
  }, [props.layout.isChannelsLoaded]);

  return (
    <div className="rd_flexrowitem dispnonemobile">
      <div className="buttonnotgcont">
        <Dropdown
          isOpen={notiDropdownOpen}
          toggle={notiToggle}
          className="profile_dropdown"
        >
          <DropdownToggle caret>
            <div className="noti_num">
              {props.notification.totalUnread > 9
                ? "9+"
                : props.notification.totalUnread}
            </div>
            <span className="rd_iconthing notbtnnav notifiexist">
              Notification
            </span>
          </DropdownToggle>

          <DropdownMenu id="scrollableDiv">
            <DropdownItem
              className="drop_options d-flex align-items-center justify-content-between mb-4"
              text
            >
              <h2>Notifications</h2>
            </DropdownItem>

            <InfiniteScroll
              dataLength={props.notification.notifications.length}
              next={loadMoreNotifications}
              hasMore={props.notification.notifications.length < totalCount}
              height={570}
              scrollableTarget="scrollableDiv"
            >
              {(props.notification.notifications || []).map(
                (notification, index) => {
                  return (
                    <>
                      <DropdownItem
                        className={notificationItemClass(notification)}
                        key={notification.id}
                      >
                        <div className="row no-gutters">
                          <div className="col-auto noti_img pr-2">
                            <div className="user_img">
                              <img
                                src="https://www.staging.meetocto.com/backend/public//uploads/profile-images/profile-1-1655986264.jpg"
                                alt="User Profile Pic"
                              />
                            </div>
                            <div className="noti_icon">
                              <img
                                src={NewScheduleIcon}
                                alt="Notificion Icon"
                              />
                            </div>
                          </div>
                          <div className="col-auto noti_txt pl-2">
                            <h4>{notification.title}</h4>
                            <p>{notification.description}</p>
                            <p className="time">
                              {moment.utc(notification.dated).local().fromNow()}
                            </p>
                          </div>
                        </div>
                      </DropdownItem>
                      <DropdownItem divider />
                    </>
                  );
                }
              )}
              <DropdownItem divider />
              <div className="view_all">
                <Link to="/admin/notifications">View All Notifications</Link>
              </div>
            </InfiniteScroll>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layout: state.layout,
  notification: state.notification,
});

export default connect(mapStateToProps, { sendPostRequest })(Notification);
